import { withInstall } from '@tav-ui/utils/with-install'
import InputNumberRange from './src/input-number-range.vue'
const TaInputNumberRange = withInstall(InputNumberRange)
export { TaInputNumberRange }
export default TaInputNumberRange
export * from './src/types'
